import { FC } from 'react';
import { observer } from 'mobx-react';
import { enumToOptions } from '@servicetitan/form-state';
import { useDependencies } from '@servicetitan/react-ioc';
import { SingleOptionProps } from '@servicetitan/design-system';
import { TenantStatus } from '@servicetitan/marketing-tenant-management-api';
import { TenantsStore } from '../../stores/tenants.store';
import { tenantStatusProps } from '../../utils/tenant-status-props';
import { MultiValueFilter } from './multi-value-filter/multi-value-filter';

const statusFilterOptions = enumToOptions(
    TenantStatus,
    value => tenantStatusProps[value].displayName,
) as SingleOptionProps[];

export const StatusFilter: FC = observer(() => {
    const [{ filterByStatus, statusesFilter }] = useDependencies(TenantsStore);

    const handleApply = (selectedValues: TenantStatus[]) => {
        filterByStatus(selectedValues);
    };

    return (
        <MultiValueFilter
            label="Status"
            onApply={handleApply}
            options={statusFilterOptions}
            appliedValues={statusesFilter}
        />
    );
});
